import { render, staticRenderFns } from "./HistoryIssue.vue?vue&type=template&id=0fc462a9&scoped=true&"
import script from "./HistoryIssue.vue?vue&type=script&lang=js&"
export * from "./HistoryIssue.vue?vue&type=script&lang=js&"
import style0 from "./HistoryIssue.vue?vue&type=style&index=0&id=0fc462a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc462a9",
  null
  
)

export default component.exports